const isDef = val => val !== undefined && val !== null && val !== '';

// BE (orders i questions) vyžaduje v patient neprázdné stringy zip, city a countryCode.
// Sdíleno mezi submit workflow guardy a validací adresy, aby FE blokoval submit dřív
// než BE vrátí 400 "Missing required location fields in patient data".
export const REQUIRED_LOCATION_FIELDS = ['zip', 'city', 'countryCode'];

export function hasRequiredLocationFields(patient = {}) {
  const data = patient || {};
  return REQUIRED_LOCATION_FIELDS.every(field => isDef(data[field]));
}

export function flattenAddressIntoPatient(metaAddr = {}, prefer = {}) {
  const meta = metaAddr || {};
  const flat = {
    lat: meta.lat,
    lon: meta.lon,
    city: meta.city,
    zip: meta.zip,
    country: meta.country,
    countryCode: meta.countryCode,
    streetName: meta.streetName,
    streetNumber: meta.streetNumber,
    addressText: meta.formatted || ''
  };

  const out = {};
  Object.keys(flat).forEach(key => {
    out[key] = isDef(prefer[key]) ? prefer[key] : isDef(flat[key]) ? flat[key] : undefined;
  });

  Object.keys(out).forEach(key => {
    if (!isDef(out[key])) {
      delete out[key];
    }
  });
  return out;
}
